import { render, staticRenderFns } from "./ExamineCard.vue?vue&type=template&id=4b6bd20c&scoped=true&"
import script from "./ExamineCard.vue?vue&type=script&lang=js&"
export * from "./ExamineCard.vue?vue&type=script&lang=js&"
import style0 from "./ExamineCard.vue?vue&type=style&index=0&id=4b6bd20c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b6bd20c",
  null
  
)

export default component.exports